import { render, staticRenderFns } from "./agreement-selector-actions.vue?vue&type=template&id=2f1f0838"
import script from "./agreement-selector-actions.vue?vue&type=script&lang=js"
export * from "./agreement-selector-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports